import React, { HTMLAttributes } from 'react';
import cn from 'classnames';

interface IChipProps extends HTMLAttributes<HTMLDivElement> {
	chipLabel: string;
	onClick?: () => void;
	className?: string;
}

const Chip = (props: IChipProps) => {
	const {
		chipLabel,
		className,
		...remainingProps
	} = props;

	return (
		<div
			className={cn('chip', className)}
			{...remainingProps}
		>
			<span>{chipLabel}</span>
		</div>
	);
};

export default Chip;
